import { render, staticRenderFns } from "./OrganizationStaffList.vue?vue&type=template&id=b639cafa&"
import script from "./OrganizationStaffList.vue?vue&type=script&lang=js&"
export * from "./OrganizationStaffList.vue?vue&type=script&lang=js&"
import style0 from "./OrganizationStaffList.vue?vue&type=style&index=0&id=b639cafa&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports